var labels = middleware['salonsLocator']['labels'];

var styles = [
    {
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#616161"
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#f5f5f5"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#bdbdbd"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#eeeeee"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.icon",
        "stylers": [
            {
                "saturation": -100
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e5e5e5"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9e9e9e"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dadada"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#616161"
            }
        ]
    },
    {
        "featureType": "road.local",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9e9e9e"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e5e5e5"
            }
        ]
    },
    {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#eeeeee"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#c9c9c9"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9e9e9e"
            }
        ]
    }
];

const mulesoftEnabled = true;

var currentPosition = {lat:41.902230,lng:12.481184};
var addressPosition = {lat:41.902230,lng:12.481184};
var position = {};
var map = null;
var markerIcons = {};
var autocomplete;
var geocoder;
var db;
var productLines = [];
var service = [];
var salontypes = {};
var mode;	//valori possibili: 'current', 'address'
var positionMarker;
var filteredSalons = [];
var markers = [];
var directionsService;
var directionsDisplay;
var itemsPerPage = 20;//per cambiare il numero di risultati per pagina della paginazione
var currentPage = 1;
var pages = 10;
var filteredSalonsNumber = 0;
var salons = [];
var markersClusters = undefined;
var timeout = 6000;
var kmToMi = 1.6;

$(document).ready(function(){

	disableEnterSubmit();
	getCurrentPosition();
	fillProductLines();
	fillSalonType();



	$("#search-salons").on('click',function(){ init('address'); });
	$("#find-position").on('click',function(){ init('current'); });

	$("#salontype, #productline").on('change',function(){ searchSalon(); });

	$("#window-switches .window-switches__switch__map").on('click',function(){
		$("#map-container").removeClass('visible');
		$("#map").removeClass('not-visible');
		$("#salon-results").removeClass('visible');
		$("#results-container .pager").removeClass('visible');
		$("#map-container").addClass('visible');
	});

	$("#window-switches .window-switches__switch__salons").on('click',function(){
		$("#map-container").removeClass('visible');
		$("#salon-results").removeClass('visible');
		$("#results-container .pager").removeClass('visible');
		$("#salon-results").addClass('visible');
		$("#map").addClass('not-visible');
		$("#results-container .pager").addClass('visible');
	});

});

//disabilita il submit alla pressione di invio
function disableEnterSubmit(){

	$("#location-form").on("submit",function(event){
		event.preventDefault();
	});

}

function showSalonsFilters(){

	$("#salons-filters").addClass('visible');
	$("#hide-salons-filters").show();
	$("#show-salons-filters").hide();

}

function hideSalonsFilters(){

	$("#salons-filters").removeClass('visible');
	$("#hide-salons-filters").hide();
	$("#show-salons-filters").show();

}

//operazioni da fare dopo aver stabilito la currentPosition
function init(m){

	currentPage = 1;

	if( m == undefined ) m = 'current';

	showOverlays(m);
	setAutocomplete();

}

//automplete sull'input dell'indirizzo
function setAutocomplete(){

	var defaultBounds = new google.maps.LatLngBounds(
		new google.maps.LatLng(position['lat'],position['lng'])
	);

	var input = document.getElementById('maps-address');
	var options = {
		bounds: defaultBounds
	};
	//$("#maps-address").off();
	autocomplete = new google.maps.places.Autocomplete(input, options);
	autocomplete = google.maps.event.addListener(autocomplete, 'place_changed', function() {

		getCoordinatesFromAddress();

	});
}

//ricava le coordinate da un indirizzo
function getCoordinatesFromAddress(){

	var address = $("#maps-address").val();

	geocoder = new google.maps.Geocoder();
	geocoder.geocode( { 'address': address}, function(results, status) {
		if (status == 'OK') {

			var lat = results[0].geometry.location.lat();
			var lng = results[0].geometry.location.lng();
			addressPosition = { lat: lat, lng: lng };
			showOverlays('address');
			setAutocomplete();
		}
	});

}

//popola la select di product lines
function fillProductLines(){

	const ajaxUrl = (mulesoftEnabled === true) ? 'https://api.davines.com/shopify/v1/salons/campaigns' : middleware['salonsLocator']['url'] + '/salons/productlines' ;

	$.ajax({
		url: ajaxUrl,
		type: 'GET'
	}).done(function(data) {

		productLines = (mulesoftEnabled === true) ? data : JSON.parse(data);

		$("#salons-filters #productline").append('<option value="all">' + labels['all'] + '</option>');

		for( var i in productLines)
			$("#salons-filters #productline").append('<option  value="' + productLines[i]['productlineid'] + '">' + productLines[i]['productline'] + '</option>');


	}).fail(function(){

		console.error("Middleware not responding");

	});
}

//popola la select di product lines
function fillSalonType(){

	const ajaxUrl = (mulesoftEnabled === true) ? 'https://api.davines.com/shopify/v1/salons/types' : middleware['salonsLocator']['url'] + '/salons/types';
	const ajaxType = (mulesoftEnabled === true) ? 'GET' : 'POST';

	$.ajax({
		url: ajaxUrl,
		type: ajaxType,
		data: { lang: middleware['salonsLocator']['lang'] },
		timeout: timeout
	}).done(function(data) {

		salontypes = (mulesoftEnabled === true) ? data : JSON.parse(data);

		$("#salons-filters #salontype").append('<option value="all">' + labels['all'] + '</option>');

		for( var i in salontypes)
			$("#salons-filters #salontype").append('<option value="' + i + '">' + salontypes[i] + '</option>');

	}).fail(function(){

		console.error("Middleware not responding");

	});

}

//rileva posizione dispositivo
function getCurrentPosition(){

	var cookiePosition = getCookie('geo_data');

	//se sono presenti le coordinate nei cookie le prendo
	if( cookiePosition != undefined ){

		cookiePosition = decodeURIComponent(cookiePosition);
		cookiePosition = JSON.parse(cookiePosition);

		currentPosition = { lat: cookiePosition.lat, lng: cookiePosition.lon }

	}

	//se è attiva la geolocalizzazione del browser prendo le coordinate del browser
	if (navigator.geolocation) {

		navigator.geolocation.getCurrentPosition(function (position) {

			currentPosition = {lat: position.coords.latitude, lng: position.coords.longitude};

			init();//init deve essere fatto al termine della geolocalizzazione altrimenti non ha le coordinate del center

		}, function () {//se la localizzazione fallisce vengono prese le coordinate ottenute in precedenza

			init();

		}, {timeout: 6000});	//dopo n secondi si passa alle coordinate ottenute in precedenza

	//altrimenti prendo le coordinate ottenute in precedenza
	}else{

		init();

	}

}

function hideOverlay(container){
	$( "#" + container + " .overlay" ).animate({
		opacity: 0
	}, 500, function() {
		$( "#" + container + " .overlay" ).animate({
			width: "0",
			height: "0"
		}, 0);
	});
}

function showOverlays(m){

	mode = m;
console.log(mode,currentPosition)
	if( mode == 'current' ){

		position = currentPosition;

	}else{

		position = addressPosition;

	}

	showOverlay('results-container');
	showOverlay('map-container');
}

function showOverlay(container){

	$( "#" + container + " .overlay" ).animate({
		width: "100%",
		height: "100%"
	}, 0, function() {

		$( "#" + container + " .overlay" ).animate({
			opacity: 1
		}, 500, function() {

			if( container == 'map-container' )changeMode();

		});

	});

}

function changeMode(){

	initMap();

	//se il marker principale è settato lo distruggo prima di ricrearlo
	if( positionMarker != undefined ) positionMarker.setMap(null);
	positionMarker = setMarker(position['lat'],position['lng'],'You',middleware['salonsLocator']['svg']['myPosition']);

	//radialDistances();

	//reinserisco i salons con la radialdistance
	//insertSalonsDb();

	setMarkersIcons();
	searchSalon();

}

//inizializza google maps
function initMap() {

	if( ! map ) {

		directionsService = new google.maps.DirectionsService();
		directionsDisplay = new google.maps.DirectionsRenderer();

		map = new google.maps.Map(document.getElementById('map'), {
			center: position,
			zoom: 13,
			disableDefaultUI: true,
			zoomControl: false,
			mapTypeControl: false,
			scaleControl: false,
			streetViewControl: false,
			rotateControl: false,
			fullscreenControl: false,
			gestureHandling: 'cooperative',
			styles: styles
		});

		directionsDisplay.setMap(map);

	}else{
		map.setCenter(position);
	}


}

//distrugge i markers
function unsetMarkers(){

	if( markersClusters ){
		markersClusters.clearMarkers();
		markersClusters = undefined;
	}

	for( var i in markers )
		markers[i].setMap(null);

	markers = [];

}

function showInfoWindow(t){

	hideAllInfoWindows();
	t.infoWindow.open(map, t);

}

function hideAllInfoWindows(){
	for( var i in markers)
		if( markers[i].infoWindow != undefined )
			markers[i].infoWindow.close();
}

//imposta i markers della pagina
function setMarkers(){

	var markersTmp = [];
	for( var i = 0; i < filteredSalons.length; i++ ) {
		var myname = (typeof filteredSalons[i]['businessname'] != 'undefined' && filteredSalons[i]['businessname'] != '') ? filteredSalons[i]['businessname'] : filteredSalons[i]['name'];
		var marker = setMarker(parseFloat(filteredSalons[i]['latitude']), parseFloat(filteredSalons[i]['longitude']), myname, markerIcons[filteredSalons[i]['type']]);
		markers[i] = marker;

		markers[i].infoWindow = new google.maps.InfoWindow({
			content: createHtmlItem(i),
			map: map
		});
		markers[i].addListener('click', function() { showInfoWindow(this); });

		markersTmp.push(markers[i]);//per new MarkerClusterer(...) è necessario che l'indice parta da 0

	}

	markersClusters = new MarkerClusterer( map, markersTmp, { styles: [
	    {
            url: middleware['salonsLocator']['svg']['cluster'],
            height: 40,
            width: 40,
            anchor: [0, 0],
            textColor: '#ffffff',
            textSize: 10
        }
    ]});
        //{ imagePath: 'https://us.davines.com/cdn/shop/t/6/assets/davines_locator-cluster' } );

	hideOverlay('map-container');

}

//imposta un marker
function setMarker(lat,lng,title,icon){

	var myLatLng = {lat: lat, lng: lng};

	return new google.maps.Marker({
		position: myLatLng,
		map: map,
		title: title,
		icon: icon
	});

}

//definizione icone dei markers
function setMarkersIcons() {

	markerIcons = {
		'davines salon': {
			url: middleware['salonsLocator']['svg']['davinesPin'],
            //origin: new google.maps.Point(0, 0),
            //anchor: new google.maps.Point(0, 0)
		},
		'sustainable beauty partner': {
			url: middleware['salonsLocator']['svg']['multibrandPin'],
            //origin: new google.maps.Point(0, 0),
            //anchor: new google.maps.Point(0, 0)
		}
	};

}

function searchSalon() {

	var range = $("#maps-range").val();
	if( range == 'all' || range == null || range == '' ) range = 100000;

	var productline = $("#productline").val();
	if( productline == 'all' ) productline = '';

	var salontype = $("#salontype").val();
	if( salontype == 'all' ) salontype = '';

	const ajaxUrl = (mulesoftEnabled === true) ? 'https://api.davines.com/shopify/v1/salons' : middleware['salonsLocator']['url'] + '/salons/nearests';
	const ajaxType = (mulesoftEnabled === true) ? 'GET' : 'POST';
	const ajaxData = (mulesoftEnabled === true) ? { latitude: position['lat'], longitude: position['lng'], division: 'HC', radius: range, campaign: productline, type: salontype, page: currentPage, rows: itemsPerPage } : { latitude: position['lat'], longitude: position['lng'], radius: range, page: currentPage, productlineid: productline, limit: itemsPerPage, salontype: salontype };

	$.ajax({
		url: ajaxUrl,
		type: ajaxType,
		data: ajaxData,
		timeout: timeout
	}).done(function(data) {

		data = (mulesoftEnabled === true) ? data : JSON.parse(data);

		filteredSalons = (mulesoftEnabled === true) ? data['rows'] : data['nearests_salons'];
		if( filteredSalons[0] == undefined ) filteredSalons = [];

		filteredSalonsNumber = data['count'];

		pages = Math.ceil( filteredSalonsNumber / itemsPerPage );

		pageButtonsAdjust();
		refresh();

	}).fail(function(){

		console.error("Middleware not responding");

	});

}

function refresh(){

	refreshList();
	refreshMarkers();

}

//ricarica la lista
function refreshList(){

	$("#salon-results").scrollTop(0);

	//calcoli per paginazione
	var start = ( currentPage - 1 ) * itemsPerPage;
	var stop = ( currentPage * itemsPerPage ) - 1;
	if( stop >= filteredSalonsNumber ) stop = filteredSalonsNumber - 1;	//se nell'ultima pagina stop supera il numero degli item

	$("#salon-results").empty();

	var text = filteredSalonsNumber + ' ' + labels['itemsFound'];
	if( filteredSalonsNumber == 1 ) text = filteredSalonsNumber + ' ' + labels['itemFound'];
	$("#salons-found").text( text );

	for( var i = 0; i < filteredSalons.length; i++ ) {

		var append = createHtmlItem(i);
		append = '<li>' + append + '</li>';
		$("#salon-results").append(append);

		$("#results-container .salon-anchor").on('mouseover',function(){
			var index = $(this).attr('data-index');
			setHighlightMarker(index);
		});

		$("#results-container .salon-anchor").on('mouseleave',function(){
			var index = $(this).attr('data-index');
			unsetHighlightMarker(index);
		});

	}

	$(".page-counter").text( ( start + 1 ) + ' - ' + ( stop + 1 ) );

	hideOverlay('results-container');

}



function createHtmlItem(i){

	var type = filteredSalons[i]['type'];

	var services = filteredSalons[i]['services'] != null ? filteredSalons[i]['services'].replace("|", ", ") : '';

	var websiteUrl = (mulesoftEnabled === true) ? filteredSalons[i]['website'] : filteredSalons[i]['websiteurl'];
	if (typeof websiteUrl !== 'undefined') {
		websiteUrl = websiteUrl.toLowerCase();
		if(websiteUrl.startsWith('www.')) {
			websiteUrl = 'https://' + websiteUrl;
		}
	}

	var distance = filteredSalons[i]['distance'] != null ? filteredSalons[i]['distance'] : '';
	if( middleware['salonsLocator']['shopCurrencyIsoCode'] == 'USD' || middleware['salonsLocator']['shopCurrencyIsoCode'] == 'GBP' ) {
		distance = distance / kmToMi;
	}
    var distance = Math.round( distance * 10 ) / 10;
	var myname = (typeof filteredSalons[i]['businessname'] != 'undefined' && filteredSalons[i]['businessname'] != '') ? filteredSalons[i]['businessname'] : filteredSalons[i]['name'];
	var salonName = (typeof myname !== 'undefined') ? myname.split(' ').join('_').replace(/&amp;/g, '&').toLowerCase() : '';

	var append = '';
	append += '<div class="container salon-result-container">';
	append += 	'<a href="javascript:void(0);" class="salon-anchor" data-index="' + i + '">';
	append += 		'<div class="salon-col-one">';
    append += 			'<img class="salon-icon" alt="dav icon" src="' + markerIcons[filteredSalons[i]['type']]['url'] + '">';
    append +=           '<div class="salon-col-one__texts">';
	append += 			    '<h5 class="type">' + salontypes[type] + '</h5>';
	if( myname ){
		append += 			'<h3 class="salon-name">' + myname + '</h3>';
	}
	if( filteredSalons[i]['address'] != '' || filteredSalons[i]['city'] != '' || filteredSalons[i]['region'] != '' || filteredSalons[i]['zipcode'] != '' ){
		append += '			<p class="salon-address">' + filteredSalons[i]['address'] + '<br>' + filteredSalons[i]['city'] + ', ' + filteredSalons[i]['region'] + ' ' + filteredSalons[i]['zipcode'] + '</p>';
	}
	append +=           '</div>';
	append += 		'</div>';
	append += 		'<div class="salon-col-two">';
	append += 			'<h6 class="salon-label">' + labels['distance'] + '</h6>';
    append += 			'<p class="salon-text">' + distance;
    if( middleware['salonsLocator']['shopCurrencyIsoCode'] == 'USD' || middleware['salonsLocator']['shopCurrencyIsoCode'] == 'GBP' ) {
		append += 			' mi';
	}else{
		append += 			' km';
	}
	append +=			'</p>';
    /*if(services != ''){
        append += 			'<h6 class="salon-label">' + labels['productsAvailable'] + '</h6>';
        append += 			'<p class="salon-text">' + services + '</p>';
    }*/
	append += 		'</div>';
	append += 	'</a>';
	append += 	'<div class="salon-buttons-container">';
	if( filteredSalons[i]['telephone'] != '' ){
		append +='	<span class="salon-button">';
		append +='		<a href="tel:' + filteredSalons[i]['telephone'] + '" onclick="hideAllInfoWindows();">';
		append +='			<img src="' + middleware['salonsLocator']['svg']['callUs'] + '" alt="" class="salon-button-img" />';
		append +='			<span class="salon-button-text">' + labels['call'] + '</span>';
		append +='		</a>';
		append +='	</span>';
	}
	if( filteredSalons[i]['mail'] != '' ){
		append +='	<span class="salon-button">';
		append +='		<a href="mailto:' + filteredSalons[i]['mail'] + '" onclick="hideAllInfoWindows();">';
		append +='			<img src="' + middleware['salonsLocator']['svg']['emailUs'] + '" alt="" class="salon-button-img" />';
		append +='			<span class="salon-button-text">' + labels['email'] + '</span>';
		append +='		</a>';
		append +='	</span>';
	}
	if( websiteUrl != '' ){
		append +='	<span class="salon-button">';
		append +='		<a href="' + websiteUrl + '" target="_blank" onclick="hideAllInfoWindows();">';
		append +='			<img src="' + middleware['salonsLocator']['svg']['bookOnline'] + '" alt="" class="salon-button-img" />';
		append +='			<span class="salon-button-text">' + labels['website'] + '</span>';
		append +='		</a>';
		append +='	</span>';
	}


	append +='		<span class="salon-button">';
	//append +='			<a href="' + 'https://www.google.it/maps/dir/' + 'PortoSantElpidio' + '/' + filteredSalons[i]['address'] + ', '  + filteredSalons[i]['city'] + ',' + filteredSalons[i]['region'] + ' ' + filteredSalons[i]['zipcode'] + '  "onclick="hideAllInfoWindows();route(' + i + ');">';
	append +='			<a href="' + 'https://www.google.it/maps/dir/'  + currentPosition["lat"] + ',' +  currentPosition["lng"] + ' ' + '/'  + filteredSalons[i]['address'] + ', '  + filteredSalons[i]['city'] + ', ' + filteredSalons[i]['region'] + ' ' + filteredSalons[i]['zipcode'] + '  "onclick="hideAllInfoWindows();">';
	append +='				<img src="' + middleware['salonsLocator']['svg']['directions'] + '" alt="" class="salon-button-img" />';
	append +='				<span class="salon-button-text">' + labels['direction'] + '</span>';
	append +='			</a>';
	append +='		</span>';
	append +='	</div>';
	append +='</div>';

	return append;



}

//ricarica i markers
function refreshMarkers(){

	unsetMarkers();
	setMarkers();
	fitMapToMarkers();

}

//mostra percorso per il salon
function route(index) {

	var end = {lat:filteredSalons[index]['latitude'],lng:filteredSalons[index]['longitude']};

	var request = {
		origin: position,
		destination: end,
		travelMode: 'DRIVING'
	};

	let linkDirection = `https://www.google.com/maps/dir/?api=1&origin=${position.lat},${position.lng}&destination=${end.lat},${end.lng}`;

	if ($(window).width() >= 798) {
		directionsService.route(request, function(result, status) {
			if (status == 'OK') {
				directionsDisplay.setDirections(result);
			}
		});
	} else {
		window.open(linkDirection);
	};



}

function setHighlightMarker(index){

	markers[index].setAnimation(google.maps.Animation.BOUNCE);

}

function unsetHighlightMarker(index){

	markers[index].setAnimation(null);

}

function previousPage() {

    if( currentPage <= 0 ) return;

	currentPage--;

	searchSalon();

}

function nextPage() {

    if( currentPage >= pages ) return;

	currentPage++;

	searchSalon();

}

function pageButtonsAdjust(){

	if( currentPage > 1 ){
		$("#previous-page-button").removeClass('disabled');
	}else{
		$("#previous-page-button").addClass('disabled');
	}

	if( currentPage < pages ){
		$("#next-page-button").removeClass('disabled');
	}else{
		$("#next-page-button").addClass('disabled');
	}

}

function fitMapToMarkers(){

	if( markers.length != 0 ) {
		var bounds = new google.maps.LatLngBounds();

		bounds.extend(positionMarker.position);
		for (var i in markers)
			bounds.extend(markers[i].position);

		map.fitBounds(bounds);
	}

}

function getCookie(name){
	var cookie = document.cookie.split("; ");	// separo i blocchi di informazioni con il punto e virgola
	for (var i=0; i < cookie.length; i++) {
		var pieces = cookie[i].split("=");	// divido l'informazione name dal suo valore
		if (pieces[0] == name) {						// cerca il cookie con il nome appena definito
			return pieces[1];							// memorizza il codice in una variabile
		}
	}
}